import Vue from 'vue';
import VueRouter from 'vue-router';
import Fooldal from './views/Fooldal.vue';
import Profil from './views/Profil.vue';
import Fontosak from './views/Fontosak.vue';
import Ertesitesek from './views/Ertesitesek.vue';
import Elozmenyek from './views/Elozmenyek.vue';
import Hirek from './views/Hirek.vue';
import KiemeltKategoria from './views/KiemeltKategoria.vue';
import NepszeruHirek from './views/NepszeruHirek.vue';
import Szerzok from './views/Szerzok.vue';
import Szervezetek from './views/Szervezetek.vue';
import IframeMegjelenito from './views/IframeMegjelenito.vue';
import Hir from './views/Hir.vue';
import MegosztottHir from './views/MegosztottHir.vue';
import Kereses from './views/Kereses.vue';
import NoPermission from './views/NoPermission.vue';
import PrivateSite from './views/PrivateSite.vue';
import YoutubeVideok from './views/YoutubeVideok.vue';
import NotFound from './views/NotFound.vue';
import { embedDisabled, isTokenValid } from './utils/token';
import settings from './settings';
import { historyMiddleware } from './utils/vue/routerHistory';
import { AppStoreTypes } from './store/modules/app';
import { userService } from './services/UserService';
import store from './store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/fooldal',
    name: 'Fooldal',
    alias: '/',
    component: Fooldal,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/fontosak/:id?',
    name: 'Fontosak',
    component: Fontosak,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/ertesitesek',
    name: 'Ertesitesek',
    component: Ertesitesek,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/elozmenyek/:id?',
    name: 'Elozmenyek',
    component: Elozmenyek,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/profil',
    name: 'Profil',
    component: Profil,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/hirek/:id?',
    name: 'Hirek',
    component: Hirek,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/kiemeltKategoria/:id',
    name: 'KiemeltKategoria',
    component: KiemeltKategoria,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/nepszeruHirek/:id?',
    name: 'NepszeruHirek',
    component: NepszeruHirek,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/szerzok/:id?',
    name: 'Szerzok',
    component: Szerzok,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/szervezetek/:id?',
    name: 'Szervezetek',
    component: Szervezetek,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/hir/:id',
    name: 'Hir',
    component: Hir,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/megosztott-hir/:azon',
    name: 'MegosztottHir',
    component: MegosztottHir,
    meta: { transitionName: 'slide', auth: false },
  },
  {
    path: '/iframe-megjelenito',
    name: 'IframeMegjelenito',
    component: IframeMegjelenito,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/youtube-videok',
    name: 'YoutubeVideok',
    component: YoutubeVideok,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/kereses',
    name: 'Kereses',
    component: Kereses,
    meta: { transitionName: 'slide' },
  },
  {
    path: '/no-permission',
    name: 'NoPermission',
    component: NoPermission,
    meta: { auth: false },
  },
  {
    path: '/private-site',
    name: 'PrivateSite',
    component: PrivateSite,
    meta: { auth: false },
  },
  { path: '*', name: 'NotFound', component: NotFound },
];

export const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach(async (to, from, next) => {
  let auth = to.meta.auth ?? true;
  if (embedDisabled && to.name != 'PrivateSite') {
    next({ name: 'PrivateSite' });
    return;
  }
  if (auth && !isTokenValid()) {
    next({ name: 'NoPermission' });
  } else {
    next();
  }
});

historyMiddleware(router, () => {
  store.dispatch(AppStoreTypes.pageTransition.set, {
    value: {
      name: 'router-view-back',
      mode: '',
    },
  });
});
